
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/auth';
import { hasSuperAdminAccess } from '@/context/auth/types';
import Navigation from '@/components/Navigation';
import SuperAdminPanel from '@/components/admin/SuperAdminPanel';
import { Card, CardContent } from '@/components/ui/card';

const SuperAdmin = () => {
  const { user, isAuthenticated } = useAuth();
  
  // Only allow access to super_admin users
  const isSuperAdmin = user ? hasSuperAdminAccess(user.role) : false;
  
  if (!isAuthenticated || !isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return (
    <Navigation>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Super Admin Dashboard</h1>
          <div className="text-sm p-2 bg-yellow-100 text-yellow-800 rounded-md">
            Super Admin access
          </div>
        </div>
        
        <Card>
          <CardContent className="p-6">
            <SuperAdminPanel />
          </CardContent>
        </Card>
      </div>
    </Navigation>
  );
};

export default SuperAdmin;
